import { gql } from '@apollo/client'

import { apolloClient } from './apolloClient'

export const auditLogsQuery = gql`
  query AuditLogs(
    $first: Int
    $skip: Int
    $filter: AuditLogFilterInput
    $orderBy: [AuditLogOrderByInput!]
  ) {
    AuditLog_list(
      first: $first
      skip: $skip
      filter: $filter
      orderBy: $orderBy
    ) {
      items {
        id
        userId
        user {
          email
          name
        }
        kind
        description
        subjectType
        subjectId
        metadata
        createdDate
      }
    }
  }
`

export type AuditLog = {
  id: string
  userId: string
  user?: { email: string; name?: string | null } | null
  kind: string
  description?: string | null
  subjectType?: string | null
  subjectId?: string | null
  metadata?: unknown
  createdDate: string
}

export const getAuditLogs = async (filters?: {
  userId?: string
  kind?: string
  subjectType?: string
}): Promise<AuditLog[]> => {
  const result = await apolloClient.query({
    query: auditLogsQuery,
    variables: {
      first: 200,
      skip: 0,
      filter: filters
        ? {
            ...(filters.userId && { userId: { equals: filters.userId } }),
            ...(filters.kind && { kind: { equals: filters.kind } }),
            ...(filters.subjectType && {
              subjectType: { equals: filters.subjectType },
            }),
          }
        : undefined,
      orderBy: [{ createdDate: 'DESC' }],
    },
  })
  return ((result.data as { AuditLog_list?: { items?: AuditLog[] } })
    ?.AuditLog_list?.items ?? []) as AuditLog[]
}
